import React, { useEffect, useRef, useState } from 'react';
import { Columns, Container } from '@codeparva/ui-components-library';
import { TopBarTypes } from './topBarTypes';
import { VariantContext } from './hooks/VariantContext';
import { useWindowDimensions } from '../../../../utilities/Dimensions';
import {
  renderTopBarVariant1,
  renderTopBarVariant2,
  renderTopBarVariant3,
  renderTopBarVariant4,
} from './topBarHelper';
import { TopBarFacilityDetailsHelper } from './helpers/TopBarFacilityDetailsHelper';
import { ThemeContext } from './hooks/themeContext';
import { FontAwesomeIcon } from '../../../../utilities/iconLoader/FontAwesomeIcon';

export const TopBar = ({
  hideOnMobileDevice,
  closeButton,
  showAnnouncementBar = false,
  locationType,
  ctaText,
  locations,
  iconsConfig,
  variant,
  buttonsConfig,
  announcementInfo = '',
  onSetTopBarHeight,
  theme,
}: TopBarTypes.ITopBarData) => {
  const [openTopBar, setOpen] = useState(true);
  const { width } = useWindowDimensions(); //can use height if required
  const topBarRef = useRef<HTMLDivElement>(null);

  const AddressIcon = iconsConfig.facilityAddressIcon;
  const EmailIcon = iconsConfig.emailIDIcon;
  const MailingAddressIcon = iconsConfig.mailingAddressIcon;
  const PhoneNumberIcon = iconsConfig.phoneNumberIcon;

  const iconsList: TopBarTypes.TIconsList = {
    AddressIcon,
    EmailIcon,
    MailingAddressIcon,
    PhoneNumberIcon,
  };
  const contactDetails = locations.location.contactDetails;
  const locationtype = locationType;
  const emailIDRedirect = `mailto:${locations.location.contactDetails.emailID}`;

  const phoneNumberRedirect = locations.location.contactDetails.phoneNumber
    ? TopBarFacilityDetailsHelper(locations.location.contactDetails)
    : '';

  const redirectDetails: TopBarTypes.TRedirectDetails = {
    emailIDRedirect,
    phoneNumberRedirect,
  };
  const contactDetailsforIcons: TopBarTypes.TContactDetailsforIcons = {
    locations,
    EmailIcon,
    emailIDRedirect,
    width,
    buttonsConfig,
  };
  const handleAnnouncmentBarDisplay = () => {
    setOpen(!openTopBar);
  };

  const topBarVariantData: TopBarTypes.TTopBarVariantDataType = {
    width,
    iconsList,
    contactDetails,
    redirectDetails,
    contactDetailsforIcons,
    locationtype,
    buttonsConfig,
    ctaText,
    variant,
  };

  const renderSwitch = (variant: TopBarTypes.TVariantModes) => {
    switch (variant) {
      case 'topbar-2':
        return renderTopBarVariant2(topBarVariantData);
      case 'topbar-3':
        return renderTopBarVariant3(topBarVariantData);
      case 'topbar-4':
        return renderTopBarVariant4(topBarVariantData);
      default:
        return renderTopBarVariant1(topBarVariantData);
    }
  };

  useEffect(() => {
    function calcHeight() {
      if (onSetTopBarHeight && null !== topBarRef.current) {
        onSetTopBarHeight(topBarRef.current.clientHeight);
      }
    }
    calcHeight();
  }, []);
  const RenderAnnouncementBar = () => {
    const textColor = theme === 'light' ? 'black' : 'white';
    const sectionColor =
      theme === 'light' ? 'cp-section-bg-light' : 'cp-section-bg-dark';
    return (
      <div
        className={
          openTopBar
            ? `announcmentBarShow py-2 has-text-${textColor} ${sectionColor}`
            : 'announcmentBarHide'
        }
      >
        <div
          className={`announcmentBardata has-text-${textColor}`}
          dangerouslySetInnerHTML={{ __html: announcementInfo }}
        ></div>
        <button
          className="crossMarkButton"
          onClick={handleAnnouncmentBarDisplay}
        >
          <FontAwesomeIcon
            iconClassName={closeButton}
            style={{
              fontSize: 12,
            }}
          />
        </button>
      </div>
    );
  };
  return (
    <VariantContext.Provider value={variant}>
      <ThemeContext.Provider value={theme}>
        <div
          className={
            variant === 'topbar-3'
              ? 'topbarContainer has-background-grey-dark'
              : 'topbarContainer has-background-primary'
          }
          ref={topBarRef}
        >
          {showAnnouncementBar && announcementInfo && <RenderAnnouncementBar />}
          <div
            className={`${
              variant === 'topbar-3'
                ? 'cp-section-bg-dark'
                : 'cp-section-bg-light'
            }`}
          >
            <Container className="topBarOnlyContainer my-0">
              <Columns
                marginless
                className={
                  hideOnMobileDevice
                    ? `topBarhide ${!showAnnouncementBar && 'pt-3'}`
                    : `topBar is-tablet  ${!showAnnouncementBar && 'pt-3'}`
                }
                centered
                multiline={false}
              >
                {renderSwitch(variant)}
              </Columns>
            </Container>
          </div>
        </div>
      </ThemeContext.Provider>
    </VariantContext.Provider>
  );
};
